import React, { FC, useMemo } from 'react';
import LicenseModuleRow from './LicenseModuleRow';
import { Module, ModuleExtraData } from './types';
import { EmptyState } from '@silverfort/sf-components';

type LicenseModulesTableProps = {
    pricingModulesDisplay: any[];
    showEnabledOnly: boolean;
    licenseExtraData: Record<string, ModuleExtraData>;
};

const LicenseModulesTable: FC<LicenseModulesTableProps> = ({
    pricingModulesDisplay,
    showEnabledOnly,
    licenseExtraData
}) => {
    const pricingModuleFields = useMemo(() => {
        if (pricingModulesDisplay && pricingModulesDisplay.length > 0) {
            let modules = pricingModulesDisplay.map((module: Module) => ({
                ...(licenseExtraData[module.key] || {}),
                ...module
            }));

            if (showEnabledOnly) {
                modules = modules.filter((module) => module.onPrem?.enabled || module.cloud?.enabled);
            }

            return modules;
        }
        return [];
    }, [pricingModulesDisplay, showEnabledOnly, licenseExtraData]);

    return pricingModuleFields.length ? (
        <div className="flex flex-col gap-2">
            {pricingModuleFields.map((module) => (
                <LicenseModuleRow {...module} />
            ))}
        </div>
    ) : (
        <EmptyState
            title="No Active License"
            description="Insert a license to activate your environment."
            className="border rounded-lg w-full px-8 py-2 h-44"
        />
    );
};

export default LicenseModulesTable;
